import React, { useEffect, useRef, useState } from "react";
import { StyleSheet, Image } from 'react-native'
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import i18n from "utils/i18n";
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import _ from "lodash";
import ThemedItem from 'components/atoms/ThemedItem'
import { ThemedItemStyles } from 'styles/components/atoms/ThemedItem'
import DataItem from 'components/atoms/DataItem'
import HelperString from 'utils/helper-string'
import { DataItemStyles } from 'styles/components/atoms/DataItem'
import ThemedBlock from 'components/atoms/ThemedBlock'
import { stripHtml } from 'utils/Helper-html'
import HelperAlerts from 'utils/HelperAlerts'
import IconView from 'scenes/home/more/index/component/IconView'
import { colorList } from 'utils/colors'
import { useRoute } from '@react-navigation/native'
import FooterBar from 'components/organisms/FooterBar'
import { FooterStyles } from 'styles/components/organisms/Footer'
import NoResultsView from 'components/atoms/NoResultsView'
import LoadingComponent from 'components/atoms/Loading'
import FetchHospitalityEvents from 'utils/fetch/FetchHospitalityEvents'
import Button from 'theme/Button'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import Icon from 'components/atoms/Icon'
import { openUrl } from 'utils/helper-url'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'

const HomeBookEventsView = () => {

	const route = useRoute();
	const layoutRef = useRef()

	const eventGuid = _.get( route, ['params', 'guid'], '--' )

	const [ loading, setLoading ] = useState( true )
	const event = useSelector( state => {
		return state.data[dataConstants.EVENTS][eventGuid];
	} )

	const fetch = () => {
		FetchHospitalityEvents.fetch({
			callbackStart: setLoading.bind( this, true ),
			callbackError: setLoading.bind( this, false ),
			callbackSuccess: ({ events }) => {
				setLoading( false )
			}
		})
	}

	const onPressEvent = () => {
		HelperAlerts.alert(
			i18n.t( 'page.events.alert.title' ),
			i18n.t( 'page.events.alert.description' ),
			[
				{
					text: i18n.t( 'basic.cancel' ),
				},
				{
					text: i18n.t( 'page.events.alert.confirm' ),
					onPress: () => {
						openUrl( event.registration_url );
					}
				}
			]
		);
	}

	useEffect( () => {
		if( typeof event === 'undefined' ) {
			fetch();
			return;
		}

		setLoading( false )
	}, [] )

	let content = <LoadingComponent />;
	let footer = null;

	if( loading === false ) {

		content = (
			<NoResultsView>
				{ i18n.t('page.event.empty') }
			</NoResultsView>
		)

		if( typeof event !== 'undefined' ) {
			const dataItems = [
				<DataItem
					key={ HelperString.hash('date', event.name ) }
					identifier={ 'date' }
					icon={ <Icon icon={ IconSystemConstants.CALENDAR } style={ [ DataItemStyles.headerIcon ] } /> }
					content={ event.datetime }>

					{ i18n.t( 'constants.date' ) }
				</DataItem>
			];

			const eventDescription = stripHtml( _.get( event, 'description', null ) );
			if( !HelperString.isEmptyString( eventDescription ) ) {
				dataItems.push(
					<DataItem
						key={ HelperString.hash('description', event.name ) }
						identifier={ 'information' }
						icon={ <Icon icon={ IconSystemConstants.INFO } style={ [ DataItemStyles.headerIcon ] } /> }
						content={ eventDescription }>

						{ i18n.t( 'constants.information' ) }
					</DataItem>
				)
			}

			let accessoryLeft = (
				<IconView
					icon={ <Icon icon={ IconSystemConstants.EVENT } style={ staticStyles.iconFontSize24ColorPrimary } /> }
					style={ ThemedItemStyles.accessoryLeft }
				/>
			)

			if( event.image_url ) {
				accessoryLeft = (
					<Image
						source={{ uri: event.image_url }}
						style={ ThemedItemStyles.accessoryLeft }
					/>
				)
			}

			content = (
				<ThemedBlock
					key={ HelperString.hash( 'item-block', event.name )}
					shadow>

					<ThemedItem
						accessoryLeft={ accessoryLeft }
						accessoryLeftSize={ 50 }
						title={ event.name }
						items={ dataItems }
					/>
				</ThemedBlock>
			)

			footer = (
				<FooterBar
					buttonContainerProps={{
						fill: true
					}}
					buttons={[
						<Button
							onPress={ onPressEvent }
							style={ [ FooterStyles.button, FooterStyles.buttonFill ] }>

							{ i18n.t( 'page.events.button_registration' ) }
						</Button>
					]}
					onHeightCallback={ layoutRef.current?.setFooterHeight }
				/>
			)
		}
	}

	return (
		<ThemedSafeAreaComponentTop top={false}>
			<ThemedLayout
				contentWidth="narrow"
				ref={ layoutRef }
				topNavigation={ true }
				showBackButton={ true }
				title={ event?.name }
				footerBar={ true }>
				
				<VStack space={ ThemedValues.stackSpace }>
					{ content }
				</VStack>
			</ThemedLayout>

			{ footer }
		</ThemedSafeAreaComponentTop>
	)
}

const staticStyles = StyleSheet.create({
	iconFontSize24ColorPrimary: {
		fontSize: 24,
		color: colorList.ORANGE.primary,
	},
});

export default HomeBookEventsView;
